var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconsUnique(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 15,
    viewBox: "0 0 20 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 15H14C14.55 15 15 14.55 15 14V1C15 0.45 14.55 0 14 0H6C5.45 0 5 0.45 5 1V14C5 14.55 5.45 15 6 15ZM1 13H3C3.55 13 4 12.55 4 12V3C4 2.45 3.55 2 3 2H1C0.45 2 0 2.45 0 3V12C0 12.55 0.45 13 1 13ZM16 3V12C16 12.55 16.45 13 17 13H19C19.55 13 20 12.55 20 12V3C20 2.45 19.55 2 19 2H17C16.45 2 16 2.45 16 3Z",
    fill: "#4529AC"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsUnique);
export default __webpack_public_path__ + "static/media/IconsUnique.d809ca3a548c40fcf0d172a7fa6b5a4f.svg";
export { ForwardRef as ReactComponent };